import { DEFAULT_TENANT } from '@/config/tenants/default.config'
import { ALL_TENANTS, TENANTS } from '@/config/tenants/tenants.config'

import type { TenantConfig } from '@/config/tenants/types'

// Reads from the registry rather than returning DEFAULT_TENANT directly: the two can drift out of sync.
const fallbackTenant = (): TenantConfig => TENANTS[DEFAULT_TENANT.id] ?? DEFAULT_TENANT

export function resolveTenant(hostname: string): TenantConfig {
  // TODO: Normalize hostname (remove port for matching, convert to lowercase)
  const normalizedHost = hostname.toLowerCase().split(':')[0]

  // Find tenant by exact domain match
  const tenant = ALL_TENANTS.find((tenant) =>
    tenant.domains.some((domain) => {
      const normalizedDomain = domain.toLowerCase().split(':')[0]

      return normalizedDomain === normalizedHost
    })
  )

  return tenant ?? fallbackTenant()
}

export type Tenant = ReturnType<typeof resolveTenant>

export function resolveTenantById(tenantId: string): TenantConfig {
  return TENANTS[tenantId] ?? fallbackTenant()
}
